import { useEffect, useState } from 'react';

import LS from '../../../utils/localStorageUtils';

const SEEN_KEY = 'duels.seenRewardIds';
const SEEN_LIMIT = 200;

let cache: string[] | null = null;
const listeners = new Set<(ids: string[]) => void>();

const parse = (raw: string | null): string[] => {
	try {
		const value = JSON.parse(raw ?? '[]');
		return Array.isArray(value) ? value.filter(id => typeof id === 'string') : [];
	} catch {
		return [];
	}
};

const load = async () => {
	if (cache) return cache;
	const raw = await LS.getAsync(SEEN_KEY).catch(() => null);
	cache = cache ?? parse(raw);
	return cache;
};

const persist = (ids: string[]) => {
	try {
		LS.set(SEEN_KEY, JSON.stringify(ids));
		return true;
	} catch {
		return false;
	}
};

export const markDuelRewardSeen = async (entitlementId: string) => {
	const ids = await load();
	if (ids.includes(entitlementId)) return;
	cache = [...ids, entitlementId].slice(-SEEN_LIMIT);
	persist(cache);
	const next = cache;
	listeners.forEach(listener => listener(next));
};

export const useSeenDuelRewards = () => {
	const [ids, setIds] = useState<string[] | null>(cache);

	useEffect(() => {
		let active = true;
		listeners.add(setIds);
		load().then(loaded => {
			if (active) setIds(loaded);
		});
		return () => {
			active = false;
			listeners.delete(setIds);
		};
	}, []);

	return ids;
};
